import { useEffect } from "react"
import $api from "@/api/index"
import Menus from "./menus"
import Banner from "@/component/banner"
import styles from "./index.module.less"
import logo from "@/assets/images/logo.png"
import { connect } from "react-redux"

import { useSearchParams, useNavigate, useLocation } from "react-router-dom"

function Header({
  phone = "400-052-4008",
  regionId,
  regionName,
  regionList,
  changeRegion,
  setRegionList,
}) {
  const [search, setSearch] = useSearchParams()
  const urlRegionId = search.get("regionId")
  let currentSearch = useLocation().search

  const navigate = useNavigate()

  const getCityList = async () => {
    const { result } = await $api.region.list()
    if (urlRegionId) {
      for (let key in result) {
        const curRegion = result[key].find((f) => f._id === urlRegionId)
        if (curRegion) selectRegion(curRegion)
      }
    }
    setRegionList(result)
  }

  useEffect(() => {
    if (!Object.keys(regionList).length) {
      getCityList()
    }
  }, [])

  function selectRegion(region) {
    changeRegion(region)
    if (!region.name) return
    if (urlRegionId) {
      currentSearch = currentSearch.replace(urlRegionId, region._id)
    } else {
      currentSearch = currentSearch + `&regionId=${region._id}`
    }
    setSearch(currentSearch)
    document.querySelector(`.${styles.cityList}`).style.display = "none"
    setTimeout(() => {
      document.querySelector(`.${styles.cityList}`).style.display = ""
    }, 100)
  }
  function toHome() {
    navigate(`/${regionId ? "?regionId=" + regionId : ""}`)
  }
  return (
    <>
      <header>
        <div className={styles.inner}>
          <div className={styles.logo}>
            <img src={logo} alt="logo" onClick={toHome} />
            <div className={styles.citys}>
              {Object.keys(regionList).length > 0 && <span>{regionName}</span>}
              <div className={styles.cityList}>
                {Object.keys(regionList).map((group) => (
                  <dl key={group}>
                    <dt>{group}</dt>
                    {regionList[group] &&
                      regionList[group].map((city) => (
                        <dd
                          key={city._id}
                          onClick={() => {
                            selectRegion(city)
                          }}
                        >
                          <span>{city.name}</span>
                        </dd>
                      ))}
                  </dl>
                ))}
              </div>
            </div>
          </div>
          <div className={styles.menus}>
            <Menus />
          </div>
          <a className={styles.phone} href={"tel: " + phone}>
            <p>{phone}</p>
          </a>
        </div>
      </header>
      <Banner />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    regionId: state.region.checked._id,
    regionName: state.region.checked.name,
    regionList: state.region.list,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeRegion: (region) => {
      dispatch({ type: "SET_REGION", region })
    },
    setRegionList: (regionList) => {
      dispatch({ type: "SET_REGIONLIST", regionList })
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
